import ResponsiveMenu from "../../../../../../common/ResponsiveMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {light, regular} from "@fortawesome/fontawesome-svg-core/import.macro";
import { GlobalConsts } from "../../../../../../../styles/GlobalConsts";
import { Colors } from "../../../../../../../styles/Colors";
import CustomButtonV2 from "../../../../../../common/CustomButtonV2";
import { t } from "../../../../../../../services/i18n";
import { Tag } from "antd";
import { VStack, HStack, Divider, Circle } from "native-base";
import AppText from "../../../../../../common/AppText";
import { useDispatch } from "react-redux";
import { openModal, SETTINGS_VALUE_MODAL } from "../../../../../../../redux/modalManagerSlice";
import { EDIT_SYNC_SETTINGS } from "../../../../../../../Configs/SettingsValueModalOptions";
import IconsGenerator from "../../../../../../Icons8Generator/IconsGenerator";
import React from "react";
import { isMobile } from "../../../../../../../services/Helpers";
import { fetchApi } from "../../../../../../../services/HTTP";
import { getCalendarSync } from "../../../../../../../redux/boxSlice";
import { useToast } from "react-native-toast-notifications";
import usePermissions from "../../../../../../../services/Permissions";

const SyncRow = (props) => {
    const {item, loggedUser, onDisconnect, onConnect, disableReason} = props;
    const dispatch = useDispatch();
    const toast = useToast();
    const {has} = usePermissions();

    const options = [
        {
            title: t('edit-sync-settings'),
            id: 'edit-sync-settings',
            iconName: 'fa-pen',
            onPress: (e) => dispatch(openModal({ modalName: SETTINGS_VALUE_MODAL, props: {type: EDIT_SYNC_SETTINGS}})),
        },
        {
            title: t('disconnect-sync'),
            id: 'disconnect-sync',
            iconName: 'fa-link-simple-slash',
            onPress: () => onDisconnect(),
        },
    ]

    const getKeyBySettings = (calendarSync) => {
        if(calendarSync.status === 'active') {
            if(calendarSync.add_to_calendar && calendarSync.check_for_conflicts) return t('add-to-calendar-and-check-for-conflicts');
            else if(calendarSync.add_to_calendar) return t('add-to-calendar');
            else if(calendarSync.check_for_conflicts) return t('check-for-conflicts');
        }
        else if(calendarSync.invitation_sent) return t('invitation-sent')
        else if(calendarSync.disconnect_reason) return t('no-settings') + ' (' + t(calendarSync.disconnect_reason) + ')';
        return t('no-settings');
    }

    const getButtonByStatus = (status) => {
        if(loggedUser) {
            if(status === 'active') return (
                <ResponsiveMenu arrow={false}
                anchor={<div id="manuBookingServices-btn" style={{cursor: 'pointer', alignItems: 'center'}}>
                    <FontAwesomeIcon icon={regular('ellipsis-vertical')} fontSize={GlobalConsts.iconSize.XS}/>
                </div>}
                items={options}
                />
            )
            else return (
                <CustomButtonV2 onClick={disableReason ? null : onConnect} type="link" iconName={'fa-link-simple'} iconProps={{iconColor: Colors.newDesign.mainText, iconSize: GlobalConsts.iconSize.XS}} tooltipText={t(disableReason || 'connect-tooltip')} style={{opacity: disableReason && '50%'}}/>
            )
        }
        else if(status === 'active') {
            const staffDisconnectDisableReason = has('calendarDisconnectStaffMember') ? null : 'no-permission-disconnect-staff-sync';
            return (
                <CustomButtonV2 onClick={staffDisconnectDisableReason ? null : onDisconnect} type="link" tooltipText={t(staffDisconnectDisableReason || 'disconnect-staff-sync-tooltip')} style={{opacity: staffDisconnectDisableReason && '50%', alignItems: 'center'}} override={() =>
                    <FontAwesomeIcon icon={light('link-simple-slash')} />}/>
            )
        }
        else if(status === 'invited') { return (
            <CustomButtonV2 tooltipText={t('send-sync-invite-tooltip')} wrapperStyle={{alignItems: 'center'}} override={({color}) => <IconsGenerator width={'100%'} height={'16px'} fill={color} style={{marginInlineEnd: 0}} name={'lightPaperPlaneRotateRight'}/>} onClick={() => resendSyncInvite()}/>
        )
        }
        else return null;
    };

    const resendSyncInvite = async () => {
        try {
            await fetchApi('calendarSyncConnections/sendInvitation', 'POST', {users_boxes_ids: [item.users_boxes_id]}, false, true)
            dispatch(getCalendarSync());
            toast.show(t('sync-invite-sent-successfully'), { type: 'success', duration: 2000 });
        } catch (error) {
            console.log('error', error)
            toast.show(t('error-sending-sync-invite'), { type: 'danger', duration: 2000 });
        }
    }

    const getTagStyle = (status) => {
        if(status === 'active') return {style: {color: Colors.newDesign.mainGreen, backgroundColor: Colors.newDesign.lightGreen}, text: t('connected-sync')};
        else if(status === 'invited') return {style: {color: Colors.newDesign.purpleText, backgroundColor: Colors.newDesign.lightLightPurple}, text: t('invited')};
        else return {style: {color: Colors.newDesign.redTagText, backgroundColor: Colors.newDesign.redTagBackground}, text: t('disconnected')};
    }


    return (
        <VStack key={item.id}>
            <HStack justifyContent={'space-between'} width={'100%'} py={'1rem'}>
            <HStack width={isMobile ? '50%' : '30%'} alignItems={'center'} space={'0.5rem'}>
                {isMobile && <Circle size={'8px'} bg={getTagStyle(item.status).style.color} />}
                <AppText>{item.full_name}</AppText>
            </HStack>
            {!isMobile && <>
            <HStack width={'25%'}>
                <Tag style={{
                    ...getTagStyle(item.status).style,
                    padding: '2px 6px',
                    borderRadius: '3px',
                    borderColor: Colors.newDesign.white,
                    fontSize: '14px',
                    maxWidth: '100%',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden'
                }}>{getTagStyle(item.status).text}</Tag>
            </HStack>
            <HStack width={'30%'}><AppText>{getKeyBySettings(item)}</AppText></HStack>
            </>}
            <HStack width={'15%'} justifyContent={'center'}>
                {getButtonByStatus(item.status)}
            </HStack>
        </HStack>
        <Divider orientation="horizontal" h={'1px'} w={'100%'} bg={Colors.borderColor}/>
    </VStack>
    )
}

export default SyncRow;